exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".toolbarTitle__lP6lT{padding:0 .5em 0 0;line-height:3em;height:3em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:700;font-size:1.125em}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/layout/toolbar-title/C:/dev/globalTopBar/src/components/layout/toolbar-title/C:/dev/globalTopBar/src/components/layout/toolbar-title/styles.scss"],"names":[],"mappings":"AAAA,qBACE,mBACA,gBACA,WACA,mBACA,gBACA,uBACA,gBACA,iBAAkB,CACnB","file":"styles.scss","sourcesContent":[".toolbarTitle {\n  padding: 0 .5em 0 0;\n  line-height: 3em;\n  height: 3em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: bold;\n  font-size: 1.125em;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"toolbarTitle": "toolbarTitle__lP6lT"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/layout/toolbar-title/styles.scss
// module id = z1Rj
// module chunks = 0